export function browserIsMac() {
  return /mac/i.test(navigator.userAgent);
}
